import { lazy } from '@loadable/component';

const RebuildCart = lazy(() =>
  import(
    /* webpackChunkName: "rebuild_cart" */
    './rebuild_cart'
  )
);

export default RebuildCart;
